<template>
  <!-- 主要內容區 -->
  <div class="menu-wrap">
    <div v-if="getStep === 1" class="empty">
      <div>
        <p>
          <i class="bi bi-arrow-left-circle" style="font-size: 1.8rem"></i>
          &emsp;請先點選左方訂單資訊
        </p>
      </div>
    </div>
    <menu-list v-else></menu-list>
  </div>
  <!-- 按鈕區 -->
  <div class="button-wrap">
    <action-button v-if="!isMenuDetail"></action-button>
    <menu-button v-else></menu-button>
  </div>
  <!-- footer消息區 -->
  <div class="footer-wrap">
    <cus-button
      :text="getNews || getSystem?.erp_id + ' ' + getSystem?.name"
      :color="getNews ? 'red' : 'darkBlue'"
      :isButton="getNews ? true : false"
      fontSize="normal"
      :style="`font-size: ${getNews ? 1.8 : 1.6}rem; margin: 0; padding: 0`"
      @click="openDialog('promotionNews')"
    ></cus-button>
    <p v-if="getIsTestMode" class="test-mode">**目前為練習模式**</p>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { mapGetters } from 'vuex';
import {defineAsyncComponent, ref} from 'vue';
import { useDialog } from '@/utils/dialog';
import MenuButton from '@/components/order/right/button/MenuButton.vue';
import { useGetters, useActions } from '@/utils/mapStore';
export default {
  name: 'order-action',
  components: {
    MenuList: defineAsyncComponent(() => import('@/components/order/right/menu/MenuList.vue')),
    ActionButton: defineAsyncComponent(() => import('@/components/order/right/button/ActionButton.vue')),
    Information: defineAsyncComponent(() => import('@/components/dialog/Information.vue')),
    // MemberDialog: defineAsyncComponent(() => import('@/components/dialog/MemberDialog.vue')),
    MenuButton,
  },
  setup() {
    //使用彈窗
    const { dialogTemplate, openDialog } = useDialog();
    // const showMemberDialog = ref(false);

    const handleMemberChecked = (phone) => {
      // memberPhone.value = phone;
      // handleCheckDeviceStatus();
      alert("memberPhone.value =" + phone);
      // await doCheckMember(phone);
    };

    return { dialogTemplate, openDialog,
      // showMemberDialog,
      handleMemberChecked,
    };

  },
  computed: {
    ...mapGetters('order', ['getStep', 'getNews']),
    ...mapGetters('list', ['getTabList']),
    ...mapGetters('menuItem', ['isMenuDetail']),
    ...mapGetters('system', ['getSystem', 'getIsTestMode']),
  },


};
</script>
<style lang="scss" scoped>
.menu-wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 4px 4px 0 0;
  padding: 8px 8px 0;
}
.button-wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  padding: 0 8px 8px;
}
.empty {
  height: 100%;
  color: #fff;
  padding: 0px 3px 5px;
  div {
    height: 100%;
    background-color: $color-darkBlue;
    border-radius: 4px;
    @include flex-center-center;
  }
}
.footer-wrap {
  position: relative;
  .test-mode {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: $color-yellow;
    font-size: 1.8rem;
  }
}
</style>
